import axios from "../axios";

const getStates = () => {
    return axios.get(`/admin/state/list`).then((response) => response.data);
};

const getStatesWithDefaultSelections = () => {
    return axios.get('/docflow/applications/auto-load/employment').then((response) => response.data)
}

export default {
    getStates,
    getStatesWithDefaultSelections,
};